import { render, staticRenderFns } from "./ReportsContainer.vue?vue&type=template&id=6562b048&scoped=true"
import script from "./ReportsContainer.vue?vue&type=script&lang=js"
export * from "./ReportsContainer.vue?vue&type=script&lang=js"
import style0 from "./ReportsContainer.vue?vue&type=style&index=0&id=6562b048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6562b048",
  null
  
)

export default component.exports